import { Button } from '@material-ui/core';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { BroadcastAffiliationForm, IBroadcastAffiliationPayload } from '../components/BroadcastAffiliationForm.component';
import { IBroadcastAffiliation } from '../typings';

interface IProps extends Partial<InjectedIntlProps> {
  affiliation: IBroadcastAffiliation;
  onSave: (payload: object) => void;
  onDelete: (id: string) => void;
}

// @ts-ignore
@injectIntl
export class BroadcastAffiliationEditForm extends React.Component<IProps> {
  public render() {
    const { affiliation } = this.props;
    const m = this.props.intl!.messages;

    return (
      <BroadcastAffiliationForm
        initial={affiliation}
        onSubmit={this.handleSubmit}
        extraActions={
          <Button variant="contained" color="secondary" onClick={this.handleDelete}>
            {m.button_delete}
          </Button>
        }
      />
    );
  }

  private handleSubmit = (payload: IBroadcastAffiliationPayload) => {
    this.props.onSave({ locale: this.props.affiliation.locale, ...payload });
  };

  private handleDelete = () => {
    this.props.onDelete(this.props.affiliation.id);
  };
}
